import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { visitReviewsModuleRoutes } from '@app/visit-reviews/routes';
import { homepageModuleRoutes } from '@app/homepage/routes';
import { salonsSearchResultModuleRoutes } from '@app/salons-search-results/routes';
import { salonDetailsModuleRoutes } from '@app/salon-details/routes';
import { customerAccountModuleRoutes } from '@app/customer-account/routes';
import { authModuleRoutes } from '@app/auth/routes';
import { giftsModuleRoutes } from '@app/gifts/routes';
import { mailingModuleRoutes } from '@app/mailing/routes';
import { sharedModuleRoutes } from '@app/shared/routes';

export const bodyCssClassPropertyName = 'bodyCssClass';

const routes: Routes = [
  ...homepageModuleRoutes,
  ...salonsSearchResultModuleRoutes,
  ...salonDetailsModuleRoutes,
  ...visitReviewsModuleRoutes,
  ...sharedModuleRoutes,
  ...customerAccountModuleRoutes,
  ...authModuleRoutes,
  ...giftsModuleRoutes,
  ...mailingModuleRoutes,
  {
    path: '**',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
